import { clone, isArray, isPlainObj } from '@rehaje/shared'

import type { PatchEvent } from './types'

export function patch(target: any, event: PatchEvent): void {
  if (typeof target !== 'object' || target === null) return
  switch (event.type) {
    case 'clear': {
      target = ensureInitialPath(target, event.path, event.target)
      if (target instanceof Map || target instanceof Set) target.clear()

      break
    }
    case 'delete':
    case 'set': {
      const key = event.path.at(-1)
      if (key === undefined) return
      target = ensureInitialPath(target, event.path, event.target, -1)
      if (isArray(target) || isPlainObj(target)) {
        if (event.type === 'set') target[key as any] = clone(event.value)
        else delete target[key as any]
      } else if (target instanceof Map) {
        if (event.type === 'set') target.set(key, clone(event.value))
        else target.delete(key)
      } else if (target instanceof Set) {
        if (event.type === 'set') target.add(clone(event.value))
        else target.delete(key)
      }

      break
    }
    case 'splice': {
      target = ensureInitialPath(target, event.path, event.target ?? [])
      if (
        isArray(target) &&
        event.start !== undefined &&
        event.deleteCount !== undefined &&
        event.items !== undefined
      ) {
        target.splice(event.start, event.deleteCount, ...clone(event.items))
      }

      break
    }
    // No default
  }
}

function createStruct(reference?: any): any {
  if (isArray(reference)) return []
  if (isPlainObj(reference)) return {}
  if (reference instanceof Map) return new Map()
  if (reference instanceof Set) return new Set()
}

function ensureInitialPath(
  target: any,
  path: any[],
  reference?: any,
  offset = 0
): any {
  const length = path.length + offset
  for (let i = 0; i < length; i++) {
    if (typeof target?.get === 'function') target = target.get(path[i])
    else if (i < length - 1)
      target = target[path[i]] ??= isNaN(path[i + 1]) ? {} : []
    else if (reference === undefined) {
      target = target[path[i]] ??= isNaN(path[i + 1]) ? {} : []
    } else {
      target = target[path[i]] ??= createStruct(reference)
    }
  }
  return target
}
